import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0227 from "../../course-02/lesson-27/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "3ff1141c-9c8a-49b9-8f07-ec90771fb96e",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0227),
    lesson: lesson0227,
  },
];

export default lessonLinks;
